<template>
  <div class="login">
    <div class="login__container" v-if="!modalSuccess">
      <img src="@\assets\logo-fundacion-forge.png" alt="">
      <h2>Experiencias Educativas</h2>
      <h3>Ingresa el código de verificación que te enviamos a tu mail</h3>

      <div class="login-error" v-if="invalidActivationCode"><i class='material-icons'>error_outline</i>El código de verificación ingresado es incorrecto</div>
      <Input type="text" placeholder="Código de verifación" label="Código de verificación" v-model="activationCode" :isError="v$.activationCode.required.$invalid" :errorMessage="v$.activationCode.required.$message" />
      <div class="resend-code" @click.stop="resetModalResendCode(); modalResendCode.email = username; modalResendCode.active = true">Solicitar un código nuevo</div>

      <!-- <h4>Genera una contraseña</h4>
      <div class="password-requirements">
        <span>La contraseña debe tener:</span>
        <ul>
          <li>6 o más caracteres</li>
          <li>Al menos 1 mayúscula</li>
          <li>Al menos 1 número</li>
        </ul>
      </div> -->

      <Input placeholder="Email" v-model="username" label="Email" :isError="v$.username.$invalid" :errorMessage="v$.username.required.$invalid ? v$.username.required.$message : v$.username.email.$message" disabled="true" />
      <div class="login-error" v-if="v$.passwordConfirm.sameAsPassword.$invalid && !v$.passwordConfirm.required.$invalid && !v$.password.required.$invalid && !invalidPassword">
        <i class='material-icons'>error_outline</i>{{v$.passwordConfirm.sameAsPassword.$message}} 
      </div>
      <div class="login-error" v-if="invalidPassword && !v$.password.required.$invalid"><i class='material-icons'>error_outline</i>La contraseña no cumple los requisitos</div>
      
      <!-- <Input
      type="password"
      placeholder="Nueva contraseña"
      label="Nueva contraseña"
      v-model="password"
      :isError="v$.password.$invalid"
      :errorMessage="v$.password.required.$message"
      @input="invalidPassword = !validatePassword()"
      /> -->
      <Input
      type="password"
      placeholder="Nueva contraseña"
      label="Nueva contraseña"
      v-model="password"
      :isError="(v$.password.$dirty && v$.password.$invalid) || invalidPassword"
      @input="invalidPassword = !validatePassword()"
      />

      <!-- <Input
      type="password"
      placeholder="Confirmar contraseña"
      label="Confirmar contraseña"
      v-model="passwordConfirm"
      :isError=" v$.passwordConfirm.$invalid "
      :errorMessage="v$.passwordConfirm.required.$message "
      @input="invalidPassword = !validatePassword()"
      /> -->
      <Input
      type="password"
      placeholder="Confirmar contraseña"
      label="Confirmar contraseña"
      v-model="passwordConfirm"
      :isError="(v$.passwordConfirm.$dirty && v$.passwordConfirm.$invalid) || invalidPassword"
      @input="invalidPassword = !validatePassword()"
      />


      <div class="password-instruction"
        :class="{'password-instruction--error': (v$.password.$dirty && v$.password.required.$invalid) || invalidPassword}">
        La contraseña debe contener como mínimo 6 caracteres, incluyendo al menos 1 mayúscula y 1 número.
      </div>


      <!-- <button @click="changePassword()" class="login-btn" :disabled="awaitRequest || v$.$invalid || (invalidPassword && !v$.password.required.$invalid)">{{ awaitRequest  ? 'Procesando' : 'Confirmar' }}<i class="material-icons">arrow_forward</i></button>     -->
      <button @click="changePassword()" class="login-btn" :disabled="awaitRequest || v$.$invalid || (invalidPassword && !v$.password.required.$invalid)">{{ awaitRequest  ? 'Procesando' : 'Crear contraseña' }}<i class="material-icons">arrow_forward</i></button>  


    </div> <!-- /login-container -->

    <div v-else class="modalSuccess">
      <i class="material-icons">error_outline</i>
      <h4>Tu contraseña fue generada con éxito</h4>
      <p>Ya estamos listos.<br>Inicia sesión con tu nueva contraseña.</p>
      <div class="modalSuccess__actions">
        <button class="go-login" @click.stop="router.push('/login')">Iniciar sesión<i class="material-icons">arrow_forward</i></button>
      </div>
    </div>

    <div class="modal__overlay" v-if="modalResendCode.active" @click.stop="modalResendCode.success ? modalResendCode.active = false : ''">
      <div class="modalResendCode" @click.stop="''">
        <template v-if="!modalResendCode.success">
          <i class="material-icons">error_outline</i>
          <h4>¿No has recibido el código de verificación?</h4>
          <p>No hay problema. Enviaremos uno nuevo a:</p>
          <div class="modalResendCode__mail"><i class="material-icons-outlined">mail</i><span>{{modalResendCode.email}}</span></div>
          <div class="login-error" v-if="modalResendCode.error"><i class='material-icons'>error_outline</i>El mail ingresado no está registrado como usuario</div>
          <div class="modalResendCode__actions">
            <button class="cancel" @click.stop="modalResendCode.active = false; modalForgetPassword.error= ''">{{$t('global.CANCEL')}}</button>
            <button v-if="resendCodeTimer == null" class="confirm" @click.stop="resendCode()" :disabled="modalResendCode.awaitRequest">{{modalResendCode.awaitRequest ? 'Enviando' : 'Continuar'}}<i class="material-icons">arrow_forward</i></button>
            <button v-else class="confirm" @click.stop="resendCode()" :disabled="resendCodeTimer > 0 || modalResendCode.awaitRequest">{{ resendCodeTimer ? 'Reenviar('+resendCodeTimer+')' : 'Reenviar'}}<i class="material-icons">arrow_forward</i></button>
          </div>
        </template>
        <template v-else>
          <i class="material-icons modalResendCode__close" @click.stop="modalResendCode.active = false">close</i>
          <i class="material-icons">error_outline</i>
          <h4>Código de verificación enviado</h4>
        </template>
      </div>
    </div>

  </div>
</template> 
<script>
import { useStore } from 'vuex';
import { ref, onBeforeUnmount, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useRoute } from 'vue-router';
import useVuelidate from '@vuelidate/core';
import { required, email, helpers, sameAs } from '@vuelidate/validators';
import Input from '../components/Input.vue';

export default {
  components:{
    Input
},
  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const username = ref("");
    const password = ref("");
    const passwordConfirm = ref("");
    const activationCode = ref("");
    const awaitRequest = ref(false);
    const v$ = useVuelidate();
    const submitted = ref(false);
    const passwordType = ref('password');
    const modalSuccess = ref(false);
    const modalResendCode = ref({
      active: false,
      email: '',
      awaitRequest: false,
      error: false,
      success : false
    });
    const resetModalResendCode = () => {
      modalResendCode.value.active = false, 
      modalResendCode.value.awaitRequest = false,
      modalResendCode.value.error = false,
      modalResendCode.value.success = false
    }
    const invalidActivationCode = ref(false);
    const invalidPassword = ref(false);
    
    function onKeydown (event) {
      if (event.key === 'Enter') {
        changePassword();
      }
    }

    window.addEventListener('keydown', onKeydown);

    onBeforeUnmount(() => {
      window.removeEventListener('keydown', onKeydown);
    })

    const passwordPattern = /^[a-z0-9]+$/i
    function validateCharacter(event){
      let $invalidCharacter = event.target.parentNode.querySelector('.invalid-character');
      if(!passwordPattern.test(event.key)){
        event.preventDefault();
        $invalidCharacter.style.visibility = 'visible';
        setTimeout(()=>{
          $invalidCharacter.style.visibility = 'hidden';
        },2000)
      } 
    }

    function validatePassword() {
      let validPassword = new RegExp(/^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])([a-zA-Z0-9]{6,32})$/); //eslint-disable-line
      // validPassword.test(password.value) ? invalidPassword.value = false : invalidPassword.value = true ;
      return validPassword.test(password.value);
    }
    
    // async function changePassword() {
    //   if (!validatePassword()) {
    //     invalidPassword.value = true
    //     return
    //   } 
    //   invalidPassword.value = false
    //   submitted.value = true;
    //   awaitRequest.value = true;
    //   if (!v$.value.username.$invalid && !v$.value.password.$invalid && !v$.value.passwordConfirm.$invalid && !v$.value.activationCode.$invalid) {
    //     try {
    //       await store.dispatch('security_endPasswordRecovery', 
    //       {
    //         email: username.value, 
    //         password: password.value,
    //         passwordConfirm: passwordConfirm.value,
    //         activationCode: activationCode.value
    //       });
    //       modalSuccess.value = true;
    //     } catch (error) {
    //       if(error.response.data == 'Invalid code'){
    //         invalidActivationCode.value = true;
    //       }else{
    //         store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' });
    //       }
    //       awaitRequest.value = false;
    //       submitted.value = false;
    //     }
    //   } else {
    //     awaitRequest.value = false;
    //   }
    // }
    async function changePassword() {
      if (!validatePassword()) {
        invalidPassword.value = true;
        return;
      }
      invalidPassword.value = false;
      awaitRequest.value = true;
      try {
        await store.dispatch('security_endPasswordRecovery', {
          email: username.value, 
          password: password.value,
          passwordConfirm: passwordConfirm.value,
          activationCode: activationCode.value
        });
        modalSuccess.value = true;
      } catch (error) {
        if (error.response.data == 'Invalid code') {
          invalidActivationCode.value = true;
        } else {
          store.dispatch('notifications_create', { text: 'Ocurrió un error, intenta nuevamente' });
        }
      } finally {
        awaitRequest.value = false;
      }
    }


    const resendCodeTimer = ref(null);
    async function resendCode(){
      modalResendCode.value.awaitRequest = true;
      try {
        await store.dispatch('security_beginPasswordRecovery',{ email: modalResendCode.value.email })
        modalResendCode.value.success = true;
        resendCodeTimer.value = 60;
        let codeInterval = setInterval(()=>{
          if(resendCodeTimer.value > 0) resendCodeTimer.value--;
          else clearInterval(codeInterval);
        },1000)
      } catch (error) {
        console.log(error)
        if(error.response.data == 'User does not exist'){
          modalResendCode.value.error = true; 
        }else{
          store.dispatch('notifications_create', { text: 'Error al enviar código, intenta nuevamente' });
        }
      } finally {
        modalResendCode.value.awaitRequest = false;
      }
    }

    onMounted(()=>{
      if(route.query.email) username.value = route.query.email;
      if(route.query.code) activationCode.value = route.query.code;
    })

    return {
      router,
      username,
      password,
      passwordConfirm,
      activationCode,
      changePassword,
      validateCharacter,
      onKeydown,
      awaitRequest,
      v$,
      submitted,
      passwordType,
      modalSuccess,
      modalResendCode,
      resetModalResendCode,
      resendCode,
      resendCodeTimer,
      invalidActivationCode,
      validatePassword,
      invalidPassword
    }
  },
  validations () {
    return {
      username: { 
        required: helpers.withMessage('Este campo es requerido', required),
        email: helpers.withMessage('El formato del mail es inválido', email)
      },
      password: { 
        required: helpers.withMessage('Este campo es requerido', required)
      },
      passwordConfirm: {
        required: helpers.withMessage('Este campo es requerido', required),
        sameAsPassword: helpers.withMessage('Las contraseñas no coinciden', sameAs(this.password))
      },
      activationCode: { 
        required: helpers.withMessage('Este campo es requerido', required)
      },
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/main.scss';
$modal-max-width: 520px;
$modal-border-radius: 8px;

.login {
  min-height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  &__container {
    margin: 12px 0;
    width: 96%;
    max-width: $modal-max-width;
    display: flex;
    flex-direction: column;
    gap: 8px;
    background: #fff;
    padding: 26px 84px 26px 84px;
    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
    border-radius: $modal-border-radius;
    @media screen and (max-width: 500px) {
      padding: 24px 18px 24px 18px;
    }
    img {
      width: 72px;
      margin: auto;
    }

    h2 {
      color: $black;
      font-weight: 700;
      text-align: center;
      font-size: 20px;
    }
    h3{
      margin-bottom: 8px;
      color: $black;
      font-weight: 600;
      text-align: center;
      font-size: 15px;
    }
    h4{
      margin-top: 8px;
      margin-bottom: 4px;
      color: $black;
      font-weight: 600;
      text-align: center;
      font-size: 15px;
    }
    input {
      height: 42px;
      width: 100%;
      padding: 12px 22px;
      margin-bottom: 8px;
      background: #f6f6f6;
      border: none;
      border-radius: 26px;
      color: #7d7d7d;
 
      &::placeholder {
        color: #7d7d7d;
      }

      &.input-invalid{
        color: $login-error-color;
        border: 1px solid $login-error-color;
      }
      &.input-invalid::placeholder {
        color: $login-error-color;
      }
    }

    .resend-code{
      // margin-top: -11px;
      padding-right: 12px;
      // padding-bottom: 4px;
      text-align: right;
      font-size: 12px;
      font-weight: 500;
      color: $green;
      // text-decoration: underline;
      cursor: pointer;
    }

    .password-requirements{
      margin-bottom: 12px;
      @include flex-column;
      gap: 8px;
      font-size: 13px;
      font-weight: 600;
      ul li{
        list-style: disc inside;
      }
    }
  }
}

.password-instruction {
  font-size: 12px;
  color: #000;
  text-align: center;
}

.password-instruction--error {
  color: red;
}

.input-message {
  margin-top: -12px;
  margin-bottom: 4px;
  padding-left: 12px;
  @include icon-and-text-container;
  gap: 4px;
  font-size: 13px;
  color: $login-error-color;
  .material-icons{
    font-size: 18px;
  }
}

.login-btn {
  @include icon-and-text-container;
  justify-content: center;
  padding: 8px 0;
  margin-top: 12px;
  background: $green;
  color: #fff;
  border-radius: 24px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
  &:disabled {
    opacity: .45;
    cursor: default;
  }
}

.password_container{
  position: relative;
  width: 100%;
  height: fit-content;
  //display: flex;
  //align-items: center; 
  .material-icons {
    position: absolute;
    right: 0;
    top: 20%;
    padding-right: 12px;
    font-size: 24px;
    cursor: pointer;
    color: $black;
  }
  .invalid-character{
    //display: none;
    visibility: hidden;
    width: 206px;
    //height: 90px;
    position: absolute;
    left: 56px;
    top: -40px;
    padding: 8px;
    @include icon-and-text-container;
    background: #fff;
    border: 1px solid;
    border-radius: 12px;
    font-size: 12px;
    font-weight: 500;
    .material-icons{
      position: relative;
      padding-right: 0;
    }
  }
}

input:-webkit-autofill,input:-webkit-autofill:hover,input:-webkit-autofill:focus{
  transition: background-color 5000s ease-in-out 0s;
  font-size: 16px !important;
}

.modalResendCode, .modalSuccess{
  position: relative;
  width: 96%;
  max-width: $modal-max-width;
  @include flex-column;
  gap: 12px;
  background: #fff;
  padding: 44px 40px 54px 40px;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.25);
  color: $darkgray;
  border-radius: $modal-border-radius;
  >.material-icons{
    font-size: 32px;
  }
  h4{
    color: $black;
    font-size: 17px;
    font-weight: 600;
  }
  p{
    font-size: 14px;
    font-weight: 500;
    color: $black;
  }
  &__mail{
    margin: 12px 0 16px 0;
    @include icon-and-text-container;
    span{
      font-weight: 600;
      color: $black;
    }
  }
  &__actions{
    display: flex;
    gap: 22px;
    button{
      @include icon-and-text-container;
      background: $green;
      padding: 8px 22px;
      border-radius: 24px;
      color: #fff;
      font-weight: 500;
      font-size: 17px;
      letter-spacing: .7px;
      &:disabled{
        opacity: .5;
        cursor: default;
      }
    }
    .cancel{
      background: none;
      color: $green;
      border: 1px solid $green;
    }
  }
  @media screen and (max-width: $bpSmall) {
    padding: 44px 20px 54px 20px;
    &__actions{
      display: flex;
      justify-content: space-between;
      gap: 12px;
      flex-wrap: wrap;
      button{
        padding: 8px 20px;
      }
    }
  }
  .modalResendCode__close{
    position: absolute;
    right: 10px;
    top: 10px;
    font-size: 28px;
    color: black;
    cursor: pointer;
  }
}
.modalSuccess {
  p{
    text-align: center;
  }
  .go-login{
    margin-top: 16px;
  }
}
</style>